/**
 * Shared HubSpot attribute-path mapping (native / legacy custom-field / unified Apideck).
 * Client picker matching and server catalog / launch / hydrate resolve the same field
 * identity across dual-catalog paths through these helpers.
 */

/**
 * Unified HubSpot paths and the native property they describe. Status and probability stay
 * separate because Apideck's shapes do not match HubSpot's dealstage and forecast values.
 */
const HUBSPOT_NATIVE_PATH_BY_UNIFIED_PATH: Readonly<Record<string, string>> = {
  'opportunity.closeDate': 'native.deals.closedate',
  'opportunity.company.annualRevenue': 'native.companies.annualrevenue',
  'opportunity.company.description': 'native.companies.description',
  'opportunity.company.industry': 'native.companies.industry',
  'opportunity.company.name': 'native.companies.name',
  'opportunity.company.numberOfEmployees': 'native.companies.numberofemployees',
  'opportunity.company.phoneNumbers': 'native.companies.phone',
  'opportunity.company.type': 'native.companies.type',
  'opportunity.company.websites': 'native.companies.website',
  'opportunity.monetaryAmount': 'native.deals.amount',
  'opportunity.owner.emails': 'native.owners.email',
  'opportunity.owner.firstName': 'native.owners.firstname',
  'opportunity.owner.lastName': 'native.owners.lastname',
  'opportunity.title': 'native.deals.dealname',
  'opportunity.type': 'native.deals.dealtype',
};

const HUBSPOT_LEGACY_CUSTOM_FIELD_PREFIXES: Readonly<Record<string, string>> = {
  'opportunity.company.customFields.': 'companies',
  'opportunity.customFields.': 'deals',
};

/**
 * Keys unified, legacy custom-field, and native HubSpot paths by their native object and property.
 */
export function hubspotFieldIdentityKey(path: string) {
  const mappedPath = HUBSPOT_NATIVE_PATH_BY_UNIFIED_PATH[path];
  if (mappedPath) return mappedPath.toLowerCase();

  for (const [prefix, objectType] of Object.entries(HUBSPOT_LEGACY_CUSTOM_FIELD_PREFIXES)) {
    if (path.startsWith(prefix))
      return `native.${objectType}.${path.slice(prefix.length)}`.toLowerCase();
  }

  return path.toLowerCase();
}
